// Extend GeoJSON with TopoJSON support.
import type {Topology, Objects} from 'topojson-specification'
import type {GeoJsonProperties} from 'geojson'
import {feature} from 'topojson-client'
import type geojson from 'geojson'

const TOPO_REGEX = /\btopology\b/i

window.L.GeoJSON.extend({
  addData(data: geojson.GeoJsonObject) {
    if (TOPO_REGEX.test(data.type)) {
      const topoData = data as unknown as Topology<Objects<GeoJsonProperties>>
      for (const key in topoData.objects) {
        const geojson = feature(topoData, topoData.objects[key])
        window.L.GeoJSON.prototype.addData.call(this, geojson)
      }
    } else {
      window.L.GeoJSON.prototype.addData.call(this, data)
    }

    return this
  },
})
